<!-- admin level -->
<app-gray-bar-header id="notificationsGrayHeaderBar"
[linkList]="notificationReports"></app-gray-bar-header>
<router-outlet></router-outlet>
